import { useEffect, useState } from 'react';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

import { completionPct } from './progress';

// One request per course and page: the progress line and the home banner share it.
const pending = new Map();

function fetchPct(courseId, page) {
  const key = `${courseId} ${page}`;
  if (!pending.has(key)) {
    pending.clear();
    const url = `${getConfig().LMS_BASE_URL}/api/course_home/progress/${encodeURIComponent(courseId)}`;
    pending.set(key, getAuthenticatedHttpClient().get(url)
      .then(({ data }) => completionPct(data.completion_summary)));
  }
  return pending.get(key);
}

// The learner's completion of a course, 0-100, or null until it is known
// (and when the request fails). Fetched again when the page changes.
export default function useCourseProgress(courseId) {
  const [pct, setPct] = useState(null);
  const page = typeof window === 'undefined' ? '' : window.location.pathname;
  useEffect(() => {
    let alive = true;
    if (courseId) {
      fetchPct(courseId, page).then(p => alive && setPct(p)).catch(() => alive && setPct(null));
    }
    return () => { alive = false; };
  }, [courseId, page]);
  return pct;
}
